<template>
<div >
    <div >
        <h2 class="text-center">Welcome to Sitters Dashboard</h2>
    </div>
     
    <div >
        <div class="col-sm-3 col-sm-offset-1" >
                <div class="filters">
                    <h5><i class="fa fa-cog" /> Filters and Preferences</h5>
                    <hr>
                    <div class="checkbox">
                        <label class="text-warning small"><input type="checkbox" v-model="searchData.ShowProfileReady"><strong>Show Ready and Pending Approval Only</strong></label>
                    </div>
                    <hr>
                    <div class="checkbox">
                        <label class="small"><input type="checkbox" v-model="searchData.ShowNewRegistrations">Show New Registrations Only</label>
                    </div>
                    <div class="checkbox">
                        <label class="small"><input type="checkbox" v-model="searchData.ShowSuspendedProfiles">Show Suspended Profiles</label>
                    </div>
                    <div class="checkbox">
                        <label class="small"><input type="checkbox" v-model="searchData.IsProfileApproved">Hide Approved Profiles</label>
                    </div>
                    <div class="checkbox">
                        <label class="small"><input type="checkbox" v-model="searchData.IsRegisteredLastWeek">Show Registered within 7 days</label>
                    </div>
                    <div class="checkbox">
                        <label class="small"><input type="checkbox" v-model="searchData.ShowHalfCompleted">Show Profiles with 50% or more completed only</label>
                    </div>
                      <div class="form-location">
                        <div class="form-group">
                            <div class='form-group '>
                                <select required v-if="countriesListComp" name="serviceSelect" class="form-control " v-model="searchData.FilterCountryId">
                                  <option value="null" disabled selected hidden>Filter specific country</option>
                                  <option value="0" >All Countries</option>
                                  <option v-for="country in countriesListComp" v-bind:value="country.CountryId">
                                    {{country.CountryName}}
                                  </option>
                                </select>
                         
                            </div>
                        </div>
                           
                    </div>
                    <button class="btn btn-info btn-block" @click="resetFilters()">Reset to default</button>
                    <button class="btn btn-success btn-block" @click="applyFilters()">Apply Filters</button>
                    <button class="btn btn-danger btn-block" @click="addFreeSubscription()">Add Free Subscription Singapore</button>
                    <!--<button class="btn btn-success btn-block" @click="adjustSitterUrl()">Fix SittersRejectDate</button>-->
                    
                </div>
        </div>
        <div class="col-sm-7">
           
            <div class="col-sm-12">
                <div class="input-group col-md-12">
                    <input type="text" v-model="searchData.SearchText" @keyup.enter="getSearchText()" class="form-control input-lg" placeholder="Search Sitters, by ID, Name or Email "/>
                    <span class="input-group-addon">
                       <span class="fa fa-search"></span>
                    </span>
                    
                </div>
                <br>
            </div>
            
            <div v-if="!loading">
            <div class="col-sm-12"  v-if="sittersListComp.length>0" v-for="(sitter, index) in sittersListComp">
                <div class="sitterListbox card">
                    <div class="profile-img">
                        <img :src="sitter.ProfilePicUrl" alt="" @click="viewProfile(sitter)" class="img-responsive img-rounded" style="min-width:50px; min-height:50px; border: 1px solid #c3c3c3;" height="75" width="75"></img>
                    </div>
                    <div class="profile-body ">
                        <button @click="updateEmail(sitter.Email)" style="margin:3px;" class="btn btn-info btn-sm pull-right">Change Email</button>
                    
                                
                        <h2 style="margin-left:13px;" class="small" v-bind:class="{'confirmed': sitter.EmailConfirmed}"> {{sitter.Email}}</h2>
                            
                        <br>
                        <div class="bottom-row">
                        
                            <div class="content col-sm-4">
                                
                                <p v-if="sitter.IsAdminSuspended" class="text-danger"><strong>Profile Currently Suspended</strong></p>
                                
                                <p class="small"> SitterId: <strong>{{sitter.SitterId}}</strong></p> 
                                <p class="small"> Name: {{sitter.FirstName}} {{sitter.LastName}}</p> 
                               
                                <p style="cursor:pointer" @click="getNumber(sitter)" class="small" v-bind:class="{'confirmed': sitter.PhoneConfirmed}"><strong>Click to show phone</strong></p>
                                <p class="small"> Registration Date: {{dateFormatter(sitter.RegistrationDate)}}</p>
                                <p class="small"> Registration Method: {{sitter.Provider}}</p>
                                <p class="small"> Area: {{sitter.SitterLocationDto.AreaName}}</p>
                                <p class="small"> City: {{sitter.SitterLocationDto.CityName}}</p>
                                <p class="small"> Country: {{sitter.SitterLocationDto.CountryName}}</p>
                               <h5 >Profile Rank Rate: {{sitter.ProfileRankRate}}</h5>
                                  <select class="form-control" v-model="sitter.ProfileRankRate" v-bind:value="sitter.ProfileRankRate" @change="updateRank(sitter)">
                                        <option value="0">Rank Zero</option>
                                        <option value="1">01 </option>
                                        <option value="2">02 </option>
                                        <option value="3">03 </option>
                                        <option value="4">04 </option>
                                        <option value="5">05 </option>
                                        <option value="6">06</option>
                                        <option value="7">07</option>
                                        <option value="8">08 </option>
                                        <option value="9">09 </option>
                                        <option value="10">10 (Show first) </option>
                                </select>
                           
                            </div>
                            <div class="content col-sm-8">
                                <h5 >Profile Info</h5>
                                <p v-if="sitter.Title" class="small"> Title: {{sitter.Title}}</p> 
                                <p v-if="sitter.PublicIdUrl" class="small"><strong> Title: {{sitter.PublicIdUrl}}</strong></p> 
                                <p v-if="sitter.AboutMe" class="small"> About Me: {{sitter.AboutMe}}</p>
                                <p class="small" v-bind:class="{'confirmed': sitter.IsProfileApproved}"> Profile Status: {{sitter.PerformanceDto.ProfileStatusDto.CurrentStatus}}</p>
                                <div v-if="sitter.PerformanceDto.ProfileStatusDto.ProfileMissingInfoDtos">
                                    <p v-if="sitter.PerformanceDto.ProfileStatusDto.ProfileMissingInfoDtos.length>0" class="small"><strong> Profile Pending Items <i class="fa fa-question-circle" style="font-size:12px;color:orange"></i>:</strong></p>
                                        <div  v-for="item in sitter.PerformanceDto.ProfileStatusDto.ProfileMissingInfoDtos">
                                            <h6 v-if="item.IsRequired" class="text-danger">{{item.MissingDesc}}</h6>
                                            <h6 v-else class="text-success">{{item.MissingDesc}}</h6>
                                        </div>
                                </div>

                                                                
                                <p class="small"> Remarks</p>
                                <textarea class="form-control" rows="2" v-model="sitter.Remarks"></textarea>
                                <a href="javascript:;" style="font-size:13px;" @click="saveRemarks(sitter)" >Save Remarks</a>
                                
                            </div>
                                                    
                        </div>
                          
                                
                    <div class="bottom-row pull-right"></div>
                        
                        <br>
                        <button @click="instagramWinner(sitter)" v-show="sitter.IsInstagramWinner==false" :disabled="sitter.IsInstagramWinner==true" style="margin:3px;" class="btn btn-success btn-sm pull-right ">Make Instagram Winner</button>
                        <button @click="removeInstagramWinner(sitter)" v-show="sitter.IsInstagramWinner==true" :disabled="sitter.IsInstagramWinner==false" style="margin:3px;" class="btn btn-warning btn-sm pull-right ">Remove Instagram Winner</button>
                        <button @click="suspendProfile(sitter)" v-show="sitter.IsAdminSuspended==false" :disabled="sitter.IsAdminSuspended==true" style="margin:3px;" class="btn btn-danger btn-sm pull-right ">Suspend Profile</button>
                        <button @click="removeSuspension(sitter)" v-show="sitter.IsAdminSuspended==true" :disabled="sitter.IsAdminSuspended==false" style="margin:3px;" class="btn btn-danger btn-sm pull-right ">Remove Suspension</button>
                        <button @click="extendSubscription(sitter)" style="margin:3px;" class="btn btn-success btn-sm pull-right ">Extend Subscription 30 days</button>
                        <button @click="removeApproval(sitter)" :disabled="sitter.IsProfileApproved==false" style="margin:3px;" class="btn btn-warning btn-sm pull-right ">Remove Approval</button>
                        <button @click="approveProfile(sitter)" :disabled="sitter.IsProfileApproved==true" style="margin:3px;" class="btn btn-success btn-sm pull-right ">Approve</button>
                        <button @click="viewProfile(sitter)" style="margin:3px;" class="btn btn-info btn-sm pull-right">View Profile</button>
                        
                    </div>
                    </div>
                    <br>
                </div>
                
                </br>
                
              </div>
               <div v-if="loading">
                <div class="spinner">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
                </div>
             </div>
                <div class="col-sm-12" v-if="!loading && sittersListComp.length==0">
                    <div class="sitterListbox card"><p><i class="fa fa-warning"/> Ooopsy, no results match your search.</p></div>
                </div>  
            </div>
            
          
        </div>
       
        
    </div>
</div>
</template>
<script>
 


import auth from '../../auth/index'
import store from '../../data/store'
import commonApi from '../../services/commonApi'
import customerApi from '../../services/customerApi'


export default {
 data() {
    return {
      error: '',
      sittersList: '',
      alert: '',
      loading: true,
      searching: false,
      remarkDto: {
          SitterId: '',
          Remars: ''
      },
      updateEmailDto: {
          OldEmail: '',
          NewEmail: ''
      },
      updateRankDto: {
          SitterId: '',
          ProfileRankRate: ''
      },
      searchData: {
          SearchText: '',
          IsProfileApproved: true,
          ShowNewRegistrations: false,
          ShowProfileReady: true,
          IsRegisteredLastWeek: false,
          ShowHalfCompleted: true,
          FilterCountryId: null,
          ShowSuspendedProfiles: false,
      },
      emailConfirmed: true,
      title: "Dupaws admin control",
      pending: true
    }
  },
  updated: function(){
      $('[data-toggle="popover"]').popover();
  
        // $zopim(function (){
        //     $zopim.livechat.hideAll();
            
        // });

        
        if (this.userRoleComp!="Admin"){
            this.$router.push({path: '/404'})
            return;
        }
  },
  mounted: function () {
    

       if (sessionStorage.getItem('SearchText')!=null)
         {
             this.searchData.SearchText = sessionStorage.getItem('SearchText')
        }
    
        if (sessionStorage.getItem('IsProfileApproved')!=null)
         {
            if (sessionStorage.getItem('IsProfileApproved')=="true")
                this.searchData.IsProfileApproved = true
            else 
                this.searchData.IsProfileApproved = false
        }
    



    if (sessionStorage.getItem('ShowNewRegistrations')!=null)
         {
            if (sessionStorage.getItem('ShowNewRegistrations')=="true")
                this.searchData.ShowNewRegistrations = true
            else 
                this.searchData.ShowNewRegistrations = false
        }
    if (sessionStorage.getItem('ShowSuspendedProfiles')!=null)
         {
            if (sessionStorage.getItem('ShowSuspendedProfiles')=="true")
                this.searchData.ShowSuspendedProfiles = true
            else 
                this.searchData.ShowSuspendedProfiles = false
        }


    if (sessionStorage.getItem('ShowProfileReady')!=null)
         {
            if (sessionStorage.getItem('ShowProfileReady')=="true")
                this.searchData.ShowProfileReady = true
            else 
                this.searchData.ShowProfileReady = false
        }
    
    if (sessionStorage.getItem('FilterCountryId')!=null)
         {
            this.searchData.FilterCountryId = sessionStorage.getItem('FilterCountryId');
        }
    

    if (sessionStorage.getItem('IsRegisteredLastWeek')!=null)
        {
            if (sessionStorage.getItem('IsRegisteredLastWeek')=="true")
                this.searchData.IsRegisteredLastWeek = true
            else 
                this.searchData.IsRegisteredLastWeek = false
        }

    if (sessionStorage.getItem('ShowHalfCompleted')!=null)
    {
        if (sessionStorage.getItem('ShowHalfCompleted')=="true") //needed because session/localStorage stores values as strings not bool.
            this.searchData.ShowHalfCompleted = true
        else 
            this.searchData.ShowHalfCompleted = false
        
    }

  
    this.getFilteredSitters()



    // $zopim(function (){
    //     $zopim.livechat.hideAll();
        
    // });


    // commonApi.getSittersList(store.getters.QueryData)  //get sitters data
   

    
  },
  methods: {
      applyFilters: function(){
          this.loading = true
            this.getFilteredSitters()
      },
      resetFilters: function(){
          sessionStorage.removeItem('SearchText')
          sessionStorage.removeItem('ShowNewRegistrations')
          sessionStorage.removeItem('IsRegisteredLastWeek')
          sessionStorage.removeItem('ShowSuspendedProfiles')
          sessionStorage.removeItem('ShowHalfCompleted')
          sessionStorage.removeItem('IsProfileApproved')
          sessionStorage.removeItem('ShowProfileReady')
          sessionStorage.removeItem('FilterCountryId')
          this.loading = true
          this.searchData.SearchText = ''
          this.searchData.IsRegisteredLastWeek = false
          this.searchData.ShowSuspendedProfiles = false
          this.searchData.ShowProfileReady = true
          this.searchData.IsProfileApproved = false
          this.searchData.ShowNewRegistrations = false
          this.searchData.ShowHalfCompleted = true
          this.searchData.FilterCountryId = null


          this.getFilteredSitters()
      },
      getSearchText: function(){
           sessionStorage.setItem('SearchText', this.searchData.SearchText)
             this.loading = true
          this.getFilteredSitters()
      },
       dateFormatter: function(date){
            return moment(date).format('DD MMM YYYY')
    },
    viewProfile: function(sitter){
        this.$router.push({path:'/admin/' + sitter.SitterId})
    },
    getNumber(sitter){
        var self = this
                        $.ajax("https://www.dupaws.com/services/api/admin/getNumber/" + sitter.SitterId,  {
                            type: 'POST',
                            beforeSend: function(xhr){
                                xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                            },
                            dataType:"json",
                            contentType: "application/json; charset=utf-8",
                            crossDomain: true,
                            success: function (data) {
                                swal(sitter.FirstName + " number below:",data, "success")
                                
                            },
                            error: function () {
                                swal("","couldn't get number", "warning")
                        }
            }); 
    },
    updateEmail(email){
        var self = this
     
        swal({
            title: "Enter sitters new Email",
            type: "input",
            showCancelButton: true,
            closeOnConfirm: false,
            inputPlaceholder: "New Email"
            }, function (inputValue) {
                if (inputValue === false) return false;
                if (inputValue === "") {
                swal.showInputError("Oops, please a valid email");
                return false
                }
                else{
                self.updateEmailDto.OldEmail = email
                self.updateEmailDto.NewEmail = inputValue
                console.log('sending now')
                self.updateEmailRequest(self.updateEmailDto)
                return;

                }



            });
       
    },
    updateEmailRequest(updateEmailDto){
        var self = this
                $.ajax("https://www.dupaws.com/services/api/admin/updateEmail",  {
                    type: 'POST',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    data: JSON.stringify(updateEmailDto),
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        swal("","Email changed successfully", "success")
                        
                    },
                    error: function () {
                        swal("","Email couldn't be changed", "warning")
                    }
                }); 
                
    },
    getFilteredSitters(){
        var self = this
        $.ajax("https://www.dupaws.com/services/api/admin/getFilteredSitters/",  {
                type: 'POST',
                beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                },
                data: JSON.stringify(self.searchData),
                dataType:"json",
                contentType: "application/json; charset=utf-8",
                crossDomain: true,
                success: function (data) {
                    self.loading = false
                    self.searching = false
                    console.log(data)
                    self.sittersList = data
                    
                    
                },
                error: function (error) {
                    self.loading = false
                    self.searching = false
                    
                    
                    
                }
            }); 
    },
    removeApproval(sitter){
        var self = this
        swal({
            title: "Confirmation",
            text: "Are you sure you want to remove this approval?",
            type: "info",
            showCancelButton: true,
            confirmButtonClass: 'btn-success',
            confirmButtonText: "Yes remove!",
            closeOnConfirm: true,
            html: true
        }, function(){
            $.ajax("https://www.dupaws.com/services/api/admin/removeApproval/" + sitter.SitterId,  {
                    type: 'GET',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        sitter.IsProfileApproved = false
                    },
                    error: function () {
                    }
                }); 
        });

      
    },
    saveRemarks(sitter){
        var url = "";
        var self = this
        self.remarkDto.SitterId = sitter.SitterId
        self.remarkDto.Remarks = sitter.Remarks

        $.ajax('https://www.dupaws.com/services/api/admin/saveRemarks/',  {
            type: 'POST',
            beforeSend: function(xhr){
                xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
            },
            data: JSON.stringify(self.remarkDto),
            dataType:"json",
            contentType: "application/json; charset=utf-8",
            crossDomain: true,
            success: function (data) {
                swal("Success","Sitter Remarks Saved","success")
                
            },
            error: function () {
            }
        }); 
    },
    suspendProfile(sitter){
        var self = this

          swal({
            title: "Confirmation",
            text: "Are you sure you want to suspend this profile?",
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: 'btn-danger',
            confirmButtonText: "Yes suspend!",
            closeOnConfirm: true,
            html: true
        }, function(){
            $.ajax("https://www.dupaws.com/services/api/admin/suspendSitter/" + sitter.SitterId,  {
                    type: 'GET',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        sitter.IsAdminSuspended = true
                    },
                    error: function () {
                    }
                }); 
        });

       
    },
    instagramWinner(sitter){
        var self = this
          swal({
            title: "Confirmation",
            text: "Are you sure you want to make this sitter a winner?",
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: 'btn-success',
            confirmButtonText: "Yes please!",
            closeOnConfirm: true,
            html: true
        }, function(){
            $.ajax("https://www.dupaws.com/services/api/admin/instagramWinner/" + sitter.SitterId,  {
                    type: 'GET',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        sitter.IsInstagramWinner = true
                    },
                    error: function () {
                    }
                }); 
        });

       
    },
    removeInstagramWinner(sitter){
        var self = this
          swal({
            title: "Confirmation",
            text: "Are you sure you want to demote this sitter from instagram winner?",
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: 'btn-success',
            confirmButtonText: "Yes please!",
            closeOnConfirm: true,
            html: true
        }, function(){
            $.ajax("https://www.dupaws.com/services/api/admin/removeInstagramWinner/" + sitter.SitterId,  {
                    type: 'GET',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        sitter.IsInstagramWinner = false
                    },
                    error: function () {
                    }
                }); 
        });

       
    },
    updateRank(sitter){
         var self = this
          self.updateRankDto.SitterId = sitter.SitterId
          self.updateRankDto.ProfileRankRate = sitter.ProfileRankRate
          $.ajax("https://www.dupaws.com/services/api/admin/updateRank",  {
                    type: 'POST',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    data: JSON.stringify(self.updateRankDto),
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        swal("","Rank changed successfully", "success")
                        
                    },
                    error: function () {
                        swal("","Rank couldn't be changed", "warning")
                    }
                }); 
    },
    addFreeSubscription(){
         $.ajax("https://www.dupaws.com/services/api/admin/addFreeSubscription/" ,  {
                    type: 'GET',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        
                        swal("Free Subscription",data,"success");
                    },
                    error: function (error) {
                        console.log(error)
                        swal("Error",error.responseJSON.Message,"error");
                }
            
       });
    },
    removeSuspension(sitter){
        var self = this
  
          swal({
            title: "Confirmation",
            text: "Are you sure you want to remove suspespension for this profile?",
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: 'btn-danger',
            confirmButtonText: "Yes remove!",
            closeOnConfirm: true,
            html: true
        }, function(){
            $.ajax("https://www.dupaws.com/services/api/admin/removeSuspension/" + sitter.SitterId,  {
                type: 'GET',
                beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                },
                dataType:"json",
                contentType: "application/json; charset=utf-8",
                crossDomain: true,
                success: function (data) {
                    sitter.IsAdminSuspended = false
                },
                error: function () {
                }
            }); 
        });
        
    },
    approveProfile(sitter){
        var self = this
           swal({
            title: "Confirmation",
            text: "Are you sure you want to approve this profile?",
            type: "info",
            showCancelButton: true,
            confirmButtonClass: 'btn-success',
            confirmButtonText: "Yes please",
            closeOnConfirm: true,
            html: true
        }, function(){
            $.ajax("https://www.dupaws.com/services/api/admin/approveSitter/" + sitter.SitterId,  {
                    type: 'GET',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        sitter.IsProfileApproved = true
                    },
                    error: function () {
                    }
            });    
       });

  },   
    extendSubscription(sitter){
        var self = this
          swal({
            title: "Confirmation",
            text: "Are you sure you want to extend free subscription for this profile?",
            type: "info",
            showCancelButton: true,
            confirmButtonClass: 'btn-success',
            confirmButtonText: "Yes please",
            closeOnConfirm: true,
            html: true
        }, function(){
            $.ajax("https://www.dupaws.com/services/api/admin/addFreeSubscriptionDays/" + sitter.SitterId,  {
                type: 'GET',
                beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                },
                dataType:"json",
                contentType: "application/json; charset=utf-8",
                crossDomain: true,
                success: function (data) {
                swal("Done", "Sitter has been granted 30 dates, new expiry date has been set.", "info")
                },
                error: function () {
                }
             });    
       });

        
    },
    sendCustomEmail(){
        var self = this
        $.ajax("https://www.dupaws.com/services/api/admin/sendCustomEmail/",  {
                type: 'POST',
                beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                },
                dataType:"json",
                contentType: "application/json; charset=utf-8",
                crossDomain: true,
                success: function (data) {
                swal("Done", "Your message has been sent!", "info")
                },
                error: function () {
                }
             });    
    },
    
  },   
  watch:{
      'searchData.SearchText': function(){
          var self = this
          sessionStorage.setItem('SearchText', this.searchData.SearchText)
         
          
      },
      
      'searchData.IsProfileApproved': function(){
          sessionStorage.setItem('IsProfileApproved', this.searchData.IsProfileApproved)
        //   this.loading = true
        //   this.getFilteredSitters()
      },
      'searchData.ShowProfileReady': function(){
          sessionStorage.setItem('ShowProfileReady', this.searchData.ShowProfileReady)
        //   this.loading = true
        //   this.getFilteredSitters()
      },
      'searchData.FilterCountryId': function(){
          sessionStorage.setItem('FilterCountryId', this.searchData.FilterCountryId)
        //   this.loading = true
        //   this.getFilteredSitters()
      },
      'searchData.IsRegisteredLastWeek': function(){
          sessionStorage.setItem('IsRegisteredLastWeek', this.searchData.IsRegisteredLastWeek)
        //   this.loading = true
        //   this.getFilteredSitters()
      },
      'searchData.ShowNewRegistrations': function(){
          sessionStorage.setItem('ShowNewRegistrations', this.searchData.ShowNewRegistrations)
        //   this.loading = true
        //   this.getFilteredSitters()
      },
      'searchData.ShowHalfCompleted': function(){
          sessionStorage.setItem('ShowHalfCompleted', this.searchData.ShowHalfCompleted)
        //   this.loading = true
        //   this.getFilteredSitters()
      },
      'searchData.ShowSuspendedProfiles': function(){
          sessionStorage.setItem('ShowSuspendedProfiles', this.searchData.ShowSuspendedProfiles)
        //   this.loading = true
        //   this.getFilteredSitters()
      }
   },
   head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function () {
      return {
        inner: this.title
      }
    }
  },
  computed: {
    countriesListComp: function(){
      return store.getters.CountriesList
    },
    approvedProfilesTextComp: function(){
        if (this.searchData.IsProfileApproved)
            return 'Show Approved'
        else 
            return 'Hide Approved'
    },
    lastWeekProfilesComp: function(){
        if (this.searchData.IsRegisteredLastWeek)
            return 'Registered Anytime'
        else
            return 'Registered within 7 days'
    },
    errorMsg: function () {
      return this.error
    },
    alertMsg: function () {
      return this.alert
    },
    sittersListComp: function(){
        if (this.sittersList!=null)
            return this.sittersList
    },
    userRoleComp: function(){
       return store.getters.userRole
     }
    
  },
  
}

 
</script>
<style scoped>



.filters{
    padding: 10px;
    border: 1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
}

.confirmed{
    font-weight: 700;
    color: green;
}

.reviews {
    margin-bottom: 0px;
    vertical-align: bottom;
    font-size: medium;
    margin-left: 0px;

}


.align-right {
  margin-left: auto;
}

.sitterListbox {
  display:flex;
  padding: 10px;
  flex-wrap: wrap;
  
}

.bottom-row {
  display: flex;
  justify-content: space-between
}

.sitterListbox .profile-img {
  height:75px;
  width:75px;
}

.sitterListbox .profile-body {
  flex: 3;
  padding-left: 10px;
  flex-wrap:wrap;
  
  
  
}

.sitterListbox .profile-body .profile-body-details{
  display:flex;
  flex-wrap: nowrap;
}

.sitterListbox .profile-body .profile-body-aboutme {
  display: flex;
  
}

.homewrapper{
    
    display: flex;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);
    background-color: aliceblue;
    transition: 0.3s;
    border-radius: 8px;
    border-bottom-width: inherit;
}

.home-icons {
  padding:3px;
}

.sitterListbox .profile-body h2 {
  margin-top:0px;
  margin-bottom:0px;
}

.sitterListbox .profile-price {
  flex: 1;
  
}

.inline {
  display: inline;
  vertical-align: middle;
  padding-right: 1px;
  
}


.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #ffffff;
    opacity: 1;
}


.fa-heart-o {
  color:#848484; opacity: 0.7;
}


.favorite {
    color:#af1818; opacity: 0.7;
    padding-left:10px;
    
}

.favorite:hover {
    opacity: 1;
}

.favorite:active {
    
    transform: scale(1.1);
}

.card {
    /* Add shadows to create the "card" effect */
    
    transition: 0.3s;
    border:1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    
    
}



/* On mouse-over, add a deeper shadow */
.card:hover {
    box-shadow: 0 10px 16px 0 rgba(1,0,0,0.2);
    background:  aliceblue;
    opacity: 1;
    
}
    
/* Add some padding inside the card container */

</style>


// WEBPACK FOOTER //
// SittersDashboard.vue?0b506596